import CatalogSchema from "schemas/catalogs/catalog";

export const createQuery = ({ active = false, archived = false, type = "linesheet", title }) => {
    const defaultTitle = type === "linesheet" ? "Untitled Linesheet" : "Untitled List";

    return {
        body: {
            active,
            archived,
            default_pdf_template: "",
            entries: [],
            meta: {
                __actions: [],
            },
            restrictions: [],
            title: title || defaultTitle,
            type,
        },
        force: true,
        options: { method: "POST" },
        schema: CatalogSchema,
        url: "/api/v3.1/catalogs",
    };
};

export const updateQuery = (id, attributes) => {
    const attrs = { ...attributes };
    return {
        body: {
            ...attrs,
        },
        force: true,
        options: { method: "PATCH" },
        schema: CatalogSchema,
        url: `/api/v3.1/catalog/${id}`,
    };
};
